import React, { useEffect } from "react";
import PodBox from "pod-box-sdk";
import { useHistory } from "react-router-dom";

import { LoadingAnimation, CenterizedPage } from "../components";

export const Authenticating = () => {
  const history = useHistory();
  useEffect(() => {
    PodBox.auth.handleAuthenticatingPage(
      () => {
        history.push("/subscriptions");
      },
      () => {
        history.push("/");
      }
    );
  }, [history]);
  return (
    <CenterizedPage>
      <LoadingAnimation size="6rem" />
    </CenterizedPage>
  );
};
